<template>
	<div class="agoraBox">
		<div class="banner swiper" id="banner">
			<div class="swiper-wrapper">
				<div class="swiper-slide " v-for="item in banner"
					:style="{'backgroundImage':'url('+item.imageUrl+')'}">
					<p class="txt">MODEL MARKETPLACE</p>
					<p class="tip">模型市场</p>
					<p v-html="item.title" class="des" style="white-space: pre-wrap;"></p>
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>
		<div class="searchBox flexBox">
			<a-input placeholder="请输入模型名称进行搜索" v-model="pageData.keyword" />
			<div class="btn">
				<img src="../../../assets/img/product/icon_2.png" class="icon" @click="clickSearch">
			</div>
		</div>
		<ul class="tabList flexBox">
			<li v-for="(item,idx) in tabList" :class="tabIdx == idx ? 'active' : ''" @click="clickTab(idx)">
				{{item.label}}
			</li>
		</ul>
		<div class="row infoBox">
			<div class="listBox fl">
				<ul class="row">
					<li v-for="(item,idx) in modelList">
						<div class="item">
							<img :src="item.coverImage" class="icon">
							<div class="name">{{item.name}}</div>
							<div class="des">{{item.description}}</div>
							<div class="hot">热度值{{item.hotValue}}</div>
						</div>
						<div class="more" @click="clickNav(item)">
							了解详情
						</div>
					</li>
				</ul>

				<div class="loadBox" v-if="isShow">下滑加载更多</div>
			</div>

			<div class="hotBox fr">
				<div class="title">热门模型</div>
				<ul class="list">
					<li v-for="(item,idx) in hotList" v-if="hotList.length > 0" @click="clickNav(item)">
						<div class="name flexBox">
							<img :src="require('../../../assets/img/agora/icon_'+(idx > 3 ? 3 :idx)+'.png')"
								class="tag">
							<p class="txt">{{item.name}}</p>
						</div>
						<div class="des flexBox">
							<div class="val flexBox">
								<img src="../../../assets/img/agora/icon_4.png" class="icon">
								<p class="txt">{{item.starCount}}</p>
							</div>
							<div class="val flexBox">
								<img src="../../../assets/img/agora/icon_5.png" class="icon">
								<p class="txt">{{item.hotValue}}</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper, {
		Autoplay,
		Grid,
		Navigation,
		Pagination
	} from 'swiper';
	Swiper.use([Autoplay, Grid, Navigation, Pagination]);
	export default {
		name: 'Agora',
		components: {

		},
		data() {
			return {
				tabList: [{
					label: "热门",
					value: 0
				}, {
					label: "最新",
					value: 1
				}],
				tabIdx: 0,
				modelList: [],
				hotList: [],
				pageData: {
					keyword: "",
					pageNum: 0,
					pageSize: 6,
				},
				isShow: false,
				isLoad: false,
				banner: [],
				// 触摸事件相关变量
				startY: 0,
				endY: 0
			}
		},
		mounted() {
			this.getData();
			// 初始化事件监听器
			this.initEventListeners();
		},
		methods: {
			getData() {
				// 初始化热门模型列表
				this.getModelList({
					res: {
						type: "recommend",
						pageNum: 1,
						pageSize: 10
					},
					call: (res) => {
						this.hotList = res.rows
					}
				});
				// 获取轮播图数据
				this.$req("get", "/api/cms/banner/listByCode/agora_banner").then((res) => {
					console.log(res);
					this.banner = res.data;
					this.updateBanner();
				});
				// 初始化模型列表
				this.updateList()
			},
			updateList() {
				if (!this.isLoad) {
					this.isLoad = true;
					this.pageData.pageNum++;
					var list = ["hot", "new"];
					this.getModelList({
						res: {
							type: list[this.tabIdx],
							keyword: this.pageData.keyword,
							pageNum: this.pageData.pageNum,
							pageSize: this.pageData.pageSize,
						},
						call: (res) => {
							this.$nextTick(() => {
								this.modelList = this.modelList.concat(res.rows);
								this.isLoad = false;
								// 判断是否还有更多数据可以加载
								if (this.modelList.length < res.total) {
									if (!this.isShow) {
										this.isShow = true;
										this.scroll()
									}
								} else {
									if (this.isShow) {
										this.isShow = false;
										this.resetScroll();
									}
								}
							})
						}
					})
				}
			},
			resetPage() {
				this.isShow = false;
				this.isLoad = false;
				this.pageData.pageNum = 0;
				this.pageData.pageSize = 6;
			},
			clickSearch() {
				this.modelList = [];
				this.resetScroll();
				this.resetPage();
				// 重新初始化事件监听器
				this.initEventListeners();
				this.updateList();
			},
			getModelList(data) {
				this.$req("get", "/api/cms/model/list", {
					params: data.res
				}).then((res) => {
					data.call(res.data)
				});
			},
			clickTab(idx) {
				this.tabIdx = idx;
				this.clickSearch()
			},
			scroll() {
				// 确保事件监听器已添加
				this.initEventListeners();
			},
			// 初始化事件监听器
			initEventListeners() {
				// 如果已经初始化过，则不再重复初始化
				if (this.touchStartHandler) {
					return;
				}
				
				// 添加滚动事件监听
				window.addEventListener("scroll", this.checkScroll);
				// 添加移动端触摸事件监听
				this.touchStartHandler = (e) => {
					this.startY = e.touches[0].pageY;
				};
				
				this.touchEndHandler = (e) => {
					this.endY = e.changedTouches[0].pageY;
					// 如果是向上滑动且接近底部，则检查是否需要加载更多
					if (this.startY > this.endY) {
						this.checkScroll();
					}
				};
				
				window.addEventListener('touchstart', this.touchStartHandler, { passive: true });
				window.addEventListener('touchend', this.touchEndHandler, { passive: true });
			},
			checkScroll() {
				// 如果已经在加载，则不继续加载
				if (this.isLoad) {
					return;
				}
				
				// 如果已经没有更多数据了，则不继续加载
				if (!this.isShow) {
					return;
				}
				
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let windowHeight = window.innerHeight;
				let documentHeight = document.documentElement.scrollHeight;
				
				if (scrollTop + windowHeight >= documentHeight - 50) {
				    this.updateList()
				}
			},
			resetScroll() {
				// 移除事件监听器
				window.removeEventListener("scroll", this.checkScroll);
				if (this.touchStartHandler) {
					window.removeEventListener('touchstart', this.touchStartHandler);
				}
				if (this.touchEndHandler) {
					window.removeEventListener('touchend', this.touchEndHandler);
				}
			},
			clickNav(item) {
				this.$router.push({
					path: "/agoraDes",
					query: {
						id: item.id
					}
				})
			},
			updateBanner() {
				new Swiper('#banner', {
					loop: true,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					},
				})
			},
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/agora.css");
</style>